import * as constants from '../constants';

const getFormattedShiftStatus = status => {
  switch (status) {
    case constants.shift.status.created.value:
      return constants.shift.status.created.text;
    case constants.shift.status.published.value:
      return constants.shift.status.published.text;
    case constants.shift.status.acknowledged.value:
      return constants.shift.status.acknowledged.text;
    case constants.shift.status.timeOffRequested.value:
      return constants.shift.status.timeOffRequested.text;
    case constants.shift.status.timeOffApproved.value:
      return constants.shift.status.timeOffApproved.text;
    case constants.shift.status.coverageRequested.value:
      return constants.shift.status.coverageRequested.text;
    case constants.shift.status.coverageApproved.value:
      return constants.shift.status.coverageApproved.text;
    default:
      return null;
  }
};

export default getFormattedShiftStatus;